import React, { useId } from "react"

const Switch = ({
  isChecked,
  onClickHandler,
  onChange,
  disabled,
  isTitle = false,
  label,
}) => {
  const inputId = useId()

  return (
    <div className="d-flex align-items-center gap-2">
      {label ? (
        <label htmlFor={inputId} className="text-muted small mb-0">
          {label}
        </label>
      ) : null}
      <div
        className="form-check form-switch form-switch-md"
        style={label ? undefined : { width: 0 }}
      >
        <input
          type="checkbox"
          id={inputId}
          checked={!!isChecked}
          onChange={e => {
            if (typeof onChange === "function") {
              onChange(e.target.checked)
            }
          }}
          onClick={typeof onClickHandler === "function" ? onClickHandler : undefined}
          disabled={disabled}
          className="form-check-input"
          title={isTitle}
        />
      </div>
    </div>
  )
}

export default Switch
